export default __webpack_public_path__ + "static/media/hero.e6576303.jpg";